export default `#version 300 es
precision mediump float;in vec2 coord;out vec4 fragColor;uniform sampler2D inputTexture;void main(){fragColor=texture(inputTexture,coord);}`